'use client'
import { Table, TableRow, TableHeader, TableCell, TextInput, TextArea, CheckboxInput, ColorButton, ReplyMessage } from "@/components/ui";
import { Text, AtSign, Smile, SquareCheck, SquareX } from "@/assets/icons";
import { getVisitorId, updateVisitorForm } from "@/app/api";
import { useActionState, useEffect, useState } from "react";
import { defaultVisitor, visitorResponseType } from "@/types";
import { useRouter } from "next/navigation";
import Form from "next/form";

export function UpdateVisitor({ id }: { id: string }) {
    const [visitorData, setVisitorData] = useState<visitorResponseType>()
    const [state, formAction, pending] = useActionState(updateVisitorForm, {
        values: { id: '', name: '', email: '', observation: '', receiveNotifications: '' },
        errors: {},
        message: '',
    })

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getVisitorId(id)
                if (response !== undefined) {
                    setVisitorData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o visitante: ', e)
            }
        }

        fetchUser()
    }, [id])

    const router = useRouter();

    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1000);

    }
    const visitor = visitorData || defaultVisitor

    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>Enviar notificações</TableHeader>
                            <TableHeader colSpan={2}>Data de entrada</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{visitor.sequence}</TableCell>
                            <TableCell>{visitor.name}</TableCell>
                            <TableCell>{visitor.email || 'Não informado'}</TableCell>
                            <TableCell className="flex items-center">
                                {visitor.receiveNotifications
                                    ? <SquareCheck />
                                    : <SquareX />}
                            </TableCell>
                            <TableCell>{new Date(visitor.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableCell>{visitor.sequence}</TableCell>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{visitor.name}</TableCell>
                            <TableHeader>Email</TableHeader>
                            <TableCell>{visitor.email || 'Não informado'}</TableCell>
                            <TableHeader>Enviar notificações</TableHeader>
                            <TableCell className="flex items-center">
                                {visitor.receiveNotifications
                                    ? <SquareCheck />
                                    : <SquareX />}
                            </TableCell>
                            <TableHeader>Data de entrada</TableHeader>
                            <TableCell>{new Date(visitor.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <Form action={formAction} className="flex flex-col gap-3">

                <input type="hidden" name="id" defaultValue={visitor.id} />

                {/* name of visitor */}

                <div className="flex gap-2 items-center">
                    <Smile className="size-4" />
                    <label htmlFor="name">Nome</label>
                </div>
                <TextInput name="name" id="name"
                    required
                    defaultValue={visitor.name || state?.values?.name}
                    placeholder="Nome" />
                {state?.errors?.name && <p>{state.errors.name}</p>}

                {/* email of visitor */}

                <div className="flex gap-2 items-center">
                    <AtSign className="size-4" />
                    <label htmlFor="email">Email</label>
                </div>
                <TextInput name="email" id="email"
                    defaultValue={visitor.email || state?.values?.email}
                    placeholder="Email" />
                {state?.errors?.email && <p>{state.errors.email}</p>}

                {/* observation of visitor */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="observation">Observação</label>
                </div>
                <TextArea name="observation" id="observation"
                    defaultValue={visitor.observation || state?.values?.observation}
                    placeholder="Observação" />
                {state?.errors?.observation && <p>{state.errors.observation}</p>}

                {/* visitor receive notifications */}

                <div className="flex gap-2 items-center">
                    <SquareCheck className="size-4" />
                    <label htmlFor="receiveNotifications">Receber notificações</label>
                </div>
                <div className="flex flex-wrap gap-5">
                    <CheckboxInput name="receiveNotifications" id="receiveNotifications" />
                </div>
                {state?.errors?.receiveNotifications && <p>{state.errors.receiveNotifications}</p>}

                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending ? 'Atualizando...' : 'Atualizar'}
                    </ColorButton>
                </div>

            </Form>
            <ReplyMessage message={state?.message || ""} />
        </div>
    )
}